import Image from '@/components/atoms/project-builder/image';
import React from 'react';

type TemplateToggleProps = {
    isLandscapeMode: boolean;
    onToggle: (val: boolean) => void;
};

const TemplateToggle: React.FC<TemplateToggleProps> = ({ isLandscapeMode, onToggle }) => {
    const buttonBaseClass =
        'flex w-full cursor-pointer items-center gap-2 overflow-hidden border border-[#090909] px-4 py-2 text-left text-sm font-medium transition-all duration-200 ease-linear sm:text-base md:w-fit';

    const activeClass = 'bg-[#090909] text-[#fff]';

    const options = [
        {
            label: 'Portrait with full product summary',
            isActive: !isLandscapeMode,
            onClick: () => onToggle(false),
            extraClass:
                'md:border-r-none rounded-tl-[18px] rounded-tr-[18px] md:rounded-bl-[18px] md:rounded-tr-[0px]',
        },
        {
            label: 'Landscape with product summary table',
            isActive: isLandscapeMode,
            onClick: () => onToggle(true),
            extraClass:
                'md:border-l-none rounded-bl-[18px] rounded-br-[18px] md:rounded-bl-[0px] md:rounded-tr-[18px]',
        },
    ];

    const renderButton = (
        label: string,
        isActive: boolean,
        onClick: () => void,
        extraClass: string,
        index:number
    ) => (
        <button
            key={index}
            type="button"
            onClick={onClick}
            className={`${buttonBaseClass} ${extraClass} ${isActive ? activeClass : ''} !py-[8px] !px-[16px]`}
        >
            <div className="relative h-[20px] w-[20px] md:hidden">
                <Image loading="lazy" src="/images/icons/project-builder/check-white.svg" alt="Check white" fill />
            </div>

            <span className="flex-1">{label}</span>

            <div className="relative hidden h-[20px] w-[20px] md:block">
                <Image loading="lazy" src="/images/icons/project-builder/check-white.svg" alt="Check white" fill />
            </div>
        </button>
    );

    return (
        <div className="mb-[30px] flex flex-col items-center md:flex-row">
            {options.map(({ label, isActive, onClick, extraClass }, index) =>
                renderButton(label, isActive, onClick, extraClass,index)
            )}
        </div>
    );
};

export default TemplateToggle;
